import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  TWaterMeter,
  TWaterSubscriber,
  WaterMeterAuthType,
  WaterMeterLocationType,
  WaterMeterModelType,
  WaterMeterType,
} from "types/dto";
import RegionAutoComplete from "components/SpecificAutoComplete/RegionAutoComplete";
import { SortObjectByPropName } from "utils/arrayTools";
import { Enum2Array } from "utils/enumTools";
import SectionMobile from "components/mobileView/SectionMobile";
import TitleValueMobile from "components/mobileView/TitleValueMobile";

type TProps = {
  data?: TWaterSubscriber;
  isLoading?: boolean;
};

const waterMeterAuthTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterAuthType),
  "name"
);
const waterMeterTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterType),
  "name"
);
const waterMeterLocationTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterLocationType),
  "name"
);
const waterMeterModelTypeOptions = SortObjectByPropName(
  Enum2Array(WaterMeterModelType),
  "name"
);

export const SubscriberInfoMobile = (props: TProps) => {
  const { data, isLoading } = props;

  const { t } = useTranslation();

  return (
    <SectionMobile
      title={t("subscriberInfo")}
      collapsible={false}
      isLoading={isLoading}
      skeleton="text"
    >
      <div className="flex flex-col w-full gap-y-3">
        <TitleValueMobile
          title={t("subscriberName")}
          value={data?.subscriberName}
        />
        <TitleValueMobile
          title={t("mobileNumber")}
          value={data?.mobileNumber}
        />
      </div>
    </SectionMobile>
  );
};
